module.exports = __webpack_public_path__ + "img/watch.1f9a0f16.svg";